import styled, { css } from 'styled-components';

export const Svg = styled.svg.withConfig({
  shouldForwardProp: (prop) => !['isOpen'].includes(prop),
})<{ isOpen?: boolean }>`
  position: relative;
  overflow: visible;

  g {
    transform-origin: 50% 50%;
  }

  .first-line {
    transform: translateY(3px);
  }

  .second-line {
    transform: translateY(-3px);
  }

  @keyframes firstLineOpen {
    50% {
      transform: translateY(0);
    }
    100% {
      transform: rotate(-45deg);
    }
  }

  @keyframes secondLineOpen {
    50% {
      transform: translateY(0);
    }
    100% {
      transform: rotate(45deg);
    }
  }

  @keyframes firstLineClose {
    0% {
      transform: rotate(-45deg);
    }
    50% {
      transform: rotate(0);
    }
    100% {
      transform: translateY(3px);
    }
  }

  @keyframes secondLineClose {
    0% {
      transform: rotate(45deg);
    }
    50% {
      transform: rotate(0);
    }
    100% {
      transform: translateY(-3px);
    }
  }

  ${(props) =>
    props.isOpen
      ? css`
          &[data-should-animate='true'] {
            .first-line {
              animation: firstLineOpen var(--tr-slow) forwards;
            }
            .second-line {
              animation: secondLineOpen var(--tr-slow) forwards;
            }
          }
        `
      : css`
          &[data-should-animate='true'] {
            .first-line {
              animation: firstLineClose var(--tr-slow) forwards;
            }
            .second-line {
              animation: secondLineClose var(--tr-slow) forwards;
            }
          }
        `}
`;
